// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"e5c48702","345":"30fb444b","483":"79281f6e","663":"9b882865","695":"3144063d","832":"a8eee1ac"}[chunkId] + ".chunk.js";
};